import { render, staticRenderFns } from "./sum.vue?vue&type=template&id=61e95c1e&scoped=true&"
import script from "./sum.vue?vue&type=script&lang=js&"
export * from "./sum.vue?vue&type=script&lang=js&"
import style0 from "./sum.vue?vue&type=style&index=0&id=61e95c1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e95c1e",
  null
  
)

export default component.exports